import http from "@/http-common";
import security from './security';

class DeviceStatusService {
    getAll() {
        return http.get("/status", security.getConfig());
    }

    getByUuid(uuid) {    
        return http.get(`/status/uuid/${uuid}`);
    }
}

export default new DeviceStatusService();